<template>
    <div class="ext-attrs-wrap">
        <el-row>
            <el-col>
                <ExtAttrPanel
                    :lock-fields="lockFields"
                    :extattrs="extAttrList"
                    :recommend-attr-list="recommendAttrList"
                    :mode="mode"
                    empty-text="--"
                    :default-disabled="defaultDisabled"
                    :unique-flag="uniqueFlag"
                    :hide-attrs-ids="dnaAttrsIds"
                    :show-value-image="showValueImage"
                    :focused-marking-list="focusedMarkingList"
                    @skuExtAttrChange="changeSkuExtAttr"
                />
            </el-col>
        </el-row>
    </div>
</template>

<script>
import emitter from 'utils/emitter';
import ExtAttrPanel from 'components/extAttrPanel';

export default {
    componentName: 'validate-form',
    components: {
        ExtAttrPanel,
    },
    mixins: [emitter],
    props: {
        // 管理类目id
        categoryId: {
            type: [Number, String],
            required: true,
        },
        // 后台类目id
        bgCategoryId: {
            type: [Number, String],
            required: true,
        },
        // 属性类型：基础属性 1，销售规格 2，售卖属性 3，采购属性 4，内容属性 5，仓储属性 6
        attrType: {
            type: Number,
            required: true,
        },
        // 已选择的属性列表
        selectedAttrList: {
            type: Array,
            default: () => [],
        },
        // 状态 编辑还是详情
        mode: {
            type: String,
            default: 'detail',
        },
        // 是否需要过滤掉空值的扩展属性
        isFilterBlankExt: {
            type: Boolean,
            default: false,
        },
        lockFields: {
            type: Array,
            default: () => ([]),
        },
        defaultDisabled: {
            type: Boolean,
            default: false,
        },
        // 用于唯一标识key
        uniqueFlag: {
            type: [String, Number],
            default: '',
        },
        span: {
            type: Number,
            default: 12,
        },
        // dna属性中的扩展属性id集合，如果在dna属性中存在，则在扩展属性中隐藏
        dnaAttrsIds: {
            type: Array,
            default: () => ([]),
        },
        // 需要单独展示的扩展属性
        specialExtAttrIds: {
            type: Array,
            default: () => ([]),
        },
        // 不需要展示的扩展属性
        exceptExtAttrId: {
            type: Array,
            default: () => ([]),
        },
        // 需要赋默认值的扩展属性（可传多个） 格式 { attrId:扩展属性id, id:值id }
        defaultAttrsId: {
            type: Array,
            default: () => ([]),
        },
        // 是否是b货
        isDiscountSku: {
            type: Boolean,
            default: false,
        },
        // 是否显示扩展属性选中值的说明
        showValueImage: {
            type: Boolean,
            default: false,
        },
        // 推荐的扩展属性值
        recommendAttrList: {
            type: Array,
            default: () => ([]),
        },
        // c端展示重点属性
        focusedMarkingList: {
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {
            extAttrList: [],
            innerSelectedAttrList: this.selectedAttrList,
            errList: [],
            allAttrList: [],
        };
    },
    computed: {
        idsChange() {
            return {
                bgCateId: +this.bgCategoryId,
            };
        },
    },
    watch: {
        selectedAttrList(newVal) {
            this.innerSelectedAttrList = newVal;
            // this.init();
        },
        idsChange({ bgCateId }) {
            if (bgCateId) {
                this.init();
            } else {
                this.extAttrList = [];
            }
            this.innerSelectedAttrList = [];
            this.$emit('selectedExtAttrList', []);
        },
        isDiscountSku() {
            this.init(true, 'change');
        },
    },
    created() {
        if (this.bgCategoryId) {
            this.init(true);
        }
        this.$on('validate-message', this.onValid);
    },
    methods: {
        fetchAllExtAttr(cateId, bgCateId) {
            try {
                return this.$service.getNewExtAttrByCategoryId({
                    cateId,
                    bgCateId,
                });
            } catch (error) {
                return this.$message.error(error.msg || error.message || '获取扩展属性失败');
            }
        },
        async init(isFillSelected = false, type) {
            const {
                categoryId, bgCategoryId, innerSelectedAttrList, attrType,
            } = this;
            if (!type) {
                this.allAttrList = await this.fetchAllExtAttr(categoryId, bgCategoryId) || [];
            }
            const bcommodityAttrList = this.isDiscountSku ? this.allAttrList.filter((item) => item.specialDisplay !== 2) : this.allAttrList;
            // 根据属性类型，从全部属性中进行过滤
            const filterExtAttrs = bcommodityAttrList.filter((v) => +v.extType === +attrType).map((item) => {
                // 给指定的扩展属性赋值
                let selectedValues = [];
                // 查找指定的扩展属性
                const targetAttr = this.defaultAttrsId.find((items) => items.attrId === item.attrId);
                if (targetAttr && !type) {
                    // 查找指定的值
                    const targetValue = item.selectValues.find((items) => items.id === targetAttr.id);
                    if (targetValue) {
                        selectedValues = [{
                            id: targetAttr.id,
                            value: targetValue.value,
                        }];
                    }
                }
                return {
                    ...item,
                    selectedValues,
                };
            }).sort((x, y) => y.requireFlag - x.requireFlag);
            // 回显扩展属性的值，从innerSelectedAttrList中提取selectedValues，合并到filterExtAttr中
            // 页面初始化（isFillSelected为true）时回显，切换类目则清空回显数据
            if (innerSelectedAttrList && innerSelectedAttrList.length && isFillSelected) {
                innerSelectedAttrList.forEach((skuAttr) => {
                    if (skuAttr.selectedValues && skuAttr.selectedValues.length) {
                        const targetAttr = filterExtAttrs.find((item) => +item.attrId === +skuAttr.attrId);
                        if (targetAttr) {
                            targetAttr.selectedValues = skuAttr.selectedValues;
                        }
                    }
                });
            }
            // 处理 特殊展示的扩展属性
            if (this.specialExtAttrIds.length) {
                this.extAttrList = filterExtAttrs.filter((item) => this.specialExtAttrIds.includes(item.attrId));
            } else {
                this.extAttrList = filterExtAttrs;
            }
            if (this.exceptExtAttrId.length) {
                this.extAttrList = this.extAttrList.filter((item) => !this.exceptExtAttrId.includes(item.attrId));
            }
            this.$emit('attrs-loaded', this.allAttrList);
            this.$emit('selectedExtAttrList', this.extAttrList);
        },
        changeSkuExtAttr(data) {
            const index = this.extAttrList.findIndex((v) => `${v.attrId}` === `${data.attrId}`);
            if (index > -1) {
                this.$set(this.extAttrList[index], 'selectedValues', data.selectedValues);
            }
            // 仅返回某一个表单项的值
            this.$emit('extAttrChange', data);
            // 返回全部已选择的extList
            if (this.isFilterBlankExt) {
                this.$emit('selectedExtAttrList', this.extAttrList.filter((attr) => attr.selectedValues && attr.selectedValues.length).map((item) => ({ attrId: item.attrId, selectedValues: item.selectedValues })));
            } else {
                this.$emit('selectedExtAttrList', this.extAttrList.map((item) => ({ attrId: item.attrId, selectedValues: item.selectedValues })));
            }
        },
        validate() {
            this.errList = [];
            this.broadcast('validate-input', 'validate');
            if (this.errList.length) {
                this.$notify.error({
                    title: '以下信息有误: ',
                    message: this.$createElement('div', this.errList.map((item) => this.$createElement('p', item))),
                });
                return false;
            }
            return true;
        },
        onValid(msg) {
            if (msg && !this.errList.includes(msg)) {
                this.errList.push(msg);
            }
        },
    },
};
</script>
